import { CountryCode } from 'pages/Settings/pages/GeneralInfoSettings';

const US_POSTALCODE_PATTERN = new RegExp(/^\d{5}$/);
const CA_POSTALCODE_PATTERN = new RegExp(
  /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i,
);

const onPostalCodeCheck = (postalCode: string, countryCode: string): boolean => {
  if (postalCode === '') {
    return true;
  } else if (countryCode === CountryCode.US && !US_POSTALCODE_PATTERN.test(postalCode)) {
    return false;
  } else if (countryCode === CountryCode.CA && !CA_POSTALCODE_PATTERN.test(postalCode)) {
    return false;
  } else if (
    (!countryCode || countryCode === ' ') &&
    !(US_POSTALCODE_PATTERN.test(postalCode) || CA_POSTALCODE_PATTERN.test(postalCode))
  ) {
    return false;
  } else {
    return true;
  }
};

export default onPostalCodeCheck;
